<template>
  <div v-if="item.type === 'text'">
    <pop-up-text-group :item="item" />
  </div>
  <div v-else-if="item.type === 'table'">
    <pop-up-table :item="item" />
  </div>
  <div v-else-if="item.type === 'datatable'">
    <PopUpDataTable :item="item" />
  </div>
  <div v-else-if="item.type === 'timeline'">
    <pop-up-time-line :item="item" />
  </div>
  <div v-else-if="item.type === 'docs'">
    <PopUpDocs :item="item" />
  </div>
  <div
    v-else-if="
      item.type === 'datatable_with_search' ||
      item.type === 'datatable_with_search_and_actions'
    "
  >
    <PopUpDataTableWithSearch
      ref="dataFetchable"
      :itemprop="item"
      :updateDetailsData="refresher"
    />
  </div>
</template>

<script>
import PopUpTable from "@/own/components/fulfillment/asn/popup/PopUpTable.vue";
import PopUpDataTable from "@/own/components/fulfillment/asn/popup/PopUpDataTable.vue";
import PopUpTextGroup from "@/own/components/fulfillment/asn/popup/PopUpTextGroup.vue";
import PopUpDocs from "@/own/components/fulfillment/asn/popup/PopUpDocs.vue";
import PopUpTimeLine from "@/own/components/fulfillment/asn/popup/PopUpTimeLine.vue";
import PopUpDataTableWithSearch from "@/own/components/fulfillment/asn/popup/PopUpDataTableWithSearch.vue";
export default {
  name: "PopUpSelector",
  props: ["item", "id", "refresher", "toggleDetail", "deleteDocUrl"],
  components: {
    PopUpTable,
    PopUpTextGroup,
    PopUpTimeLine,
    PopUpDocs,
    PopUpDataTable,
    PopUpDataTableWithSearch,
  },
  methods: {
    fetchData() {
      try {
        this.$refs?.dataFetchable?.getDataFromApi();
      } catch {
        return;
      }
    },
  },
};
</script>
